import { Occasion } from '@shelter/models/occasion.model';
import { environment } from '../../environments/environment';

// export const uri = `https://backend.um-in.com/v1`;
//export const uri = environment.uri;
export const uri = environment.url;
export const publicUri = environment.url;
// export const uri = `http://192.168.1.71:5001/v1`;

export const API_URLS = {
    Auth: {
        login: uri + '/Auth/login',
        logout: uri + '/Auth/logout',
        loginByToken: uri + '/Auth/loginByToken',
        exists: uri + '/auth/exists/{username}',
        changePassword: uri + '/User/updatePassword',
    },
    Staff: {
        post: uri + '/Staff',
        getAll: uri + '/Staff',
        resetPassword: uri + '/Staff/resetPassword/{id}',
        updatePassword: uri + '/Staff/password/update',
        getOne: uri + '/Staff/{id}',
        delete: uri + '/Staff/{id}',
        update: uri + '/Staff/{id}',
        getOrganizers: uri + '/Staff/organizers',
    },
    User: {
        post: uri + '/User',
        getAll: uri + '/User',
        filterByType: uri + '/User/filterByType',
        getOne: uri + '/User/{id}',
        delete: uri + '/User/{id}',
        update: uri + '/User/{id}',
        resetPassword: uri + '/Staff/resetPassword/{id}',
        updatePassword: uri + '/Staff/password/update',
        checkMobileExist : uri + '/User/userNameByMobile/{mobile}'
    },
    Banner: {
        post: uri + '/Banner',
        getAll: uri + '/Banner',
        getOne: uri + '/Banner/{id}',
        delete: uri + '/Banner/{id}',
        update: uri + '/Banner/{id}',
    },
    EventCategory: {
        post: uri + '/Category',
        getAll: uri + '/Category',
        getOne: uri + '/Category/{id}',
        delete: uri + '/Category/{id}',
        update: uri + '/Category/{id}',
    },
    TicketCategory: {
        post: uri + '/TicketCategory',
        getAll: uri + '/TicketCategory',
        getOne: uri + '/TicketCategory/{id}',
        delete: uri + '/TicketCategory/{id}',
        update: uri + '/TicketCategory/{id}',
    },
    City: {
        post: uri + '/City',
        getAll: uri + '/City',
        getOne: uri + '/City/{id}',
        delete: uri + '/City/{id}',
        update: uri + '/City/{id}',
    },
    WelcomePage: {
        post: uri + '/Onboarding',
        getAll: uri + '/Onboarding',
        getOne: uri + '/Onboarding/{id}',
        delete: uri + '/Onboarding/{id}',
        update: uri + '/Onboarding/{id}',
    },
    Sponsor: {
        post: uri + '/Sponsor',
        getAll: uri + '/Sponsor',
        getOne: uri + '/Sponsor/{id}',
        delete: uri + '/Sponsor/{id}',
        update: uri + '/Sponsor/{id}',
    },
    Role: {
        post: uri + '/role',
        getAll: uri + '/role',
        getOne: uri + '/role/{id}',
        update: uri + '/role/{id}',
        delete: uri + '/role/{id}',
    },
    Occasion: {
        post: uri + '/Event',
        getAll: uri + '/Event',
        getAllFilter: uri + '/Event/getAllEventsForAdmin',
        updateEvent: uri + '/Event/{id}',
        deleteEvent: uri + '/Event/{id}',
        getOneEvent: uri + '/Event/{id}',
        getEventTicktes: uri + '/Event/ticket/{id}',
        //-----------
        paginated: uri + '/Occasion/paginated',
        getOne: uri + '/Occasion/{id}',
        delete: uri + '/Occasion/{id}',
        updateOccasion: uri + '/Occasion/{id}',
        update: uri + '/Occasion/updateOccasion/{id}',
        updateChart: uri + '/Event/updateChart/{id}',
        updateBasicInfo: uri + '/Occasion/updateBasicInfo/{id}',
        updateAdditionalInfo: uri + '/Occasion/updateAdditionalInfo/{id}',
        getCategoriesEvents: uri + '/Event/getCategoriesEvents',
        getAllEventsNames: uri + '/Event/getAllEventsNames',
        assignOrganizerToEvent: uri + '/Event/assignOrganizerToEvent',
        getEventOrganizers: uri + '/Event/eventOrganizers/{id}',
        getSeatsDataFromSeatsIo:
            uri + '/Booking/seatsStatusFromSeatsio/{occasionId}/{dateId}',
        getSeatsDataFromDB:
            uri + '/Booking/seatsStatusFromDB/{occasionId}/{dateId}',
        uploadExcel: uri + '/Booking/invitation/{occasionId}',
        assignSupplier: uri + '/Occasion/assignSupplier/{id}',
        occasionOrganizer: uri + '/Occasion/assignOrganizer/{id}',
        assignedOcassions: uri + '/Occasion/organizerOccasions',
        tempBooking: uri + '/Booking/tempProviderBooking/{id}/{dateId}',
        reservedDates: uri + '/Booking/reservedDates/{id}',
        tempPrintTicket: uri + '/Booking/tempPrintTicket',
        reservedByDates: uri + '/Booking/seatsStatusFromDB/{id}/{dateId}',
        tempPrintTicketByCode: uri + '/Booking/tempPrintTicketByCode',
        getOrganizers : uri + '/Event/{eventId}/organizers'
      
    },
    Payment: {
        paymentSession: uri + '/Payment/session/{id}',
    },
    language: {
        // getAll : uri + '/Language',
        // getById : uri + '/Language/{id}',
        // edit : uri + '/Language/{id}',
        translate: uri + '/Language',
        // delete: uri + '/Language/{id}'
    },
    localization: {
        getAll: uri + '/Localization',
        getById: uri + '/Localization/getLocalization/{id}',
        // edit : uri + '/localization/{id}',
        // add : uri + '/localization/add',
        delete: uri + '/localization/{id}',
    },
    Ticket: {
        providerReservation: uri + '/Ticket/providerReservation/{id}',
        getOne: uri + '/Ticket/{id}',
        print: uri + '/Ticket/print/{id}',
    },
    chart: {
        post: uri + '/chart',
        getAll: uri + '/chart',
        getPublicKey: uri + '/chart/publicKey',
        getOne: uri + '/chart/{id}',
        delete: uri + '/chart/{id}',
        update: uri + '/chart/{id}',
        chartCategories: uri + '/chart/getChartCategories/{id}',
        retrieveCart: uri + '/chart/retrieveChart/{id}',
        checkChart: uri + '/chart/validateChart/{id}',
    },
    Booking: {
        bookingHistory: uri + '/Booking/bookingHistory/{id}',
        attendenceHistory: uri + '/Attendance/history/{eventId}',
        printTicketbyId: uri + '/Booking/print/{eventId}/{ticketLineId}',
        todaySales: uri + '/Booking/todaySales',
        //----------------------
        ApplyBooking: uri + '/Booking/provider/{occasionId}',
        myBookings: uri + '/Booking/myBookings',
        bookingFilter: uri + '/Booking/bookingsFilter',
        // printTickets: uri + '/Booking/print',
        //----------------------
        bookEvent: uri + '/Booking/{id}',
        //----------------------
        printTickets: uri + '/Booking/printable/{code}',
        printOneTicket: uri + '/Booking/print/{id}',
        getTicketById: uri + '/Booking/ticket/{id}',
        getReservations: uri + '/Booking/findAll',
        printInvitations: uri + '/Booking/tempPrintInvitations?occasionId={id}',
        tempPrintTicket: uri + '/Booking/tempPrintTicket?ticketId={id}',
        totalBookings: uri + '/Booking/totalBookings/{occasionId}',
        reservationsAndCount:
            uri + '/Booking/reservationsAndCount/{occasionId}/{dateId}',
        invitationsAndCount:
            uri + '/Booking/invitationsAndCount/{occasionId}/{dateId}',
        visitorsAndCount:
            uri + '/Booking/visitorsAndCount/{occasionId}/{dateId}',
        attendanceAndCount:
            uri + '/Booking/attendanceAndCount/{occasionId}/{dateId}',
        depatureAndCount:
            uri + '/Booking/depatureAndCount/{occasionId}/{dateId}',
            // =================================
            getEventTickets: uri + '/Booking/getTicket/{eventId}',
    },
    Settings: {
        SISecretKey: uri + '/settings/SeatsKey/{type}',
        get: uri + '/Settings',
        put: uri + '/Settings',
    },
    File: {
        upload: uri + '/File/upload',
        uploadMultiple: uri + '/File/uploadMultiple',
        get: uri + '/File/{imgPath}',
        download: uri + '/File/',
        view: uri + '/File/view?imgpath=',
    },
    contact: {
        get: uri + '/ContactUs',
        updateReply: uri + '/ContactUs/{id}',
        delete: uri + '/ContactUs/{id}',
    },

    Attendance: {
        get: uri + '/Attendance/byOccasionAndDate/{occasionId}/{dateId}',
    },
    Artist: {
        post: uri + '/Artist',
        getAll: uri + '/Artist',
        getOne: uri + '/Artist/{id}',
        delete: uri + '/Artist/{id}',
        update: uri + '/Artist/{id}',
    },
    PromoCodes: {
        post: uri + '/PromoCode',
        getAll: uri + '/PromoCode',
        getOne: uri + '/PromoCode/{id}',
        delete: uri + '/PromoCode/{id}',
        update: uri + '/PromoCode/{id}',
        check: uri + '/PromoCode/check',
    },
    Reports: {
        bookingHistory: uri + '/Booking/bookingHistory/{id}',
        bookingStatistics :uri+'/Booking/bookingHistoryStatistics/{id}'
        
    },
};
